<template>
	<div class="img-wrap text-center" :class="{'full-box display-flex-center justify-content-center': isFullSize}">
		<img
      :src="pathView"
      :class="{'full-size': isFullSize}"
      alt="Media"
    >
	</div>
</template>

<script>
	import { APP_CONFIG } from '@/utils/constants'

	export default {
		name: 'PreviewImage',
		props: {
      pathView: String,
      isFullSize: Boolean
    },
		data () {
			return {
				appUrl: APP_CONFIG.appUrl,
				urlCmsImg: APP_CONFIG.urlCmsImg
			}
		}
	}
</script>

<style lang="scss" scoped>
img {
  &:not(.full-size) {
    max-height: calc(80vh - 245px);
  }
}
</style>
